"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _WireObject2 = _interopRequireDefault(require("../WireObject"));

var _creative = require("../../constants/creative");

var _isString = _interopRequireDefault(require("../../utils/object/isString"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CreativeDocumentMask = /*#__PURE__*/function (_WireObject) {
  (0, _inherits2["default"])(CreativeDocumentMask, _WireObject);

  var _super = _createSuper(CreativeDocumentMask);

  function CreativeDocumentMask() {
    var _this;

    (0, _classCallCheck2["default"])(this, CreativeDocumentMask);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_alpha", _creative.DEFAULT_STAGE_ALPHA);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_color", _creative.DEFAULT_STAGE_COLOR);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_frameEnd", _creative.DEFAULT_CREATIVE_LENGTH);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_frameStart", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_height", _creative.DEFAULT_CREATIVE_HEIGHT_PX);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_width", _creative.DEFAULT_CREATIVE_WIDTH_PX);
    return _this;
  }

  (0, _createClass2["default"])(CreativeDocumentMask, [{
    key: "copy",
    value: function copy() {
      var json = this.toJSON();
      return CreativeDocumentMask.fromJSON(json);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        alpha: this.alpha,
        color: this.color,
        frameEnd: this.frameEnd,
        frameStart: this.frameStart,
        height: this.height,
        width: this.width
      };
    }
  }, {
    key: "alpha",
    get: function get() {
      return this._alpha;
    },
    set: function set(value) {
      this._alpha = value;
    }
  }, {
    key: "color",
    get: function get() {
      return this._color;
    },
    set: function set(color) {
      this._color = color;
    }
  }, {
    key: "frameEnd",
    get: function get() {
      return this._frameEnd;
    },
    set: function set(frameEnd) {
      this._frameEnd = frameEnd;
    }
  }, {
    key: "frameStart",
    get: function get() {
      return this._frameStart;
    },
    set: function set(frameStart) {
      this._frameStart = frameStart;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    },
    set: function set(height) {
      this._height = height;
    }
  }, {
    key: "width",
    get: function get() {
      return this._width;
    },
    set: function set(width) {
      this._width = width;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(inMask) {
      var alpha = inMask.alpha,
          color = inMask.color,
          frameEnd = inMask.frameEnd,
          frameStart = inMask.frameStart,
          height = inMask.height,
          width = inMask.width;
      var creativeDocumentMask = new CreativeDocumentMask();

      if ((0, _isNumber["default"])(alpha)) {
        creativeDocumentMask.alpha = alpha;
      }

      if ((0, _isString["default"])(color)) {
        creativeDocumentMask.color = color;
      }

      if ((0, _isNumber["default"])(frameEnd)) {
        creativeDocumentMask.frameEnd = frameEnd;
      }

      if ((0, _isNumber["default"])(frameStart)) {
        creativeDocumentMask.frameStart = frameStart;
      }

      if ((0, _isNumber["default"])(frameStart)) {
        creativeDocumentMask.height = height;
      }

      if ((0, _isNumber["default"])(frameStart)) {
        creativeDocumentMask.width = width;
      }

      return creativeDocumentMask;
    }
    /**
     * Checks if object is an instance of CreativeDocumentMask
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "isCreativeDocumentMask",
    value: function isCreativeDocumentMask(inputObject) {
      return inputObject instanceof CreativeDocumentMask;
    }
  }]);
  return CreativeDocumentMask;
}(_WireObject2["default"]);

exports["default"] = CreativeDocumentMask;